export enum StatusType {
  PROJECT = 1,
  BLOCK = 2,
  RESIDENT = 3,
  PARTNER_COMPANY = 4,
  FRANCHISE_CONTRACT = 5,
  COLLABORATOR = 6,
  ATTENDANCE = 7
}
